import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CreateStory from '../views/CreateStory.vue'
import ReadStory from '../views/ReadStory.vue'
import TitlePage from '../views/TitlePage.vue'
import Subscribe from '../views/Subscribe.vue'
import Unsubscribe from '../views/Unsubscribe.vue'
import Policies from '../views/policies/Policies.vue'
import NotFound from '../views/NotFound.vue'
import HowItWorks from '../views/HowItWorks.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Add to the Story'
    }
  },
  {
    path: '/policies',
    name: 'Policies',
    component: Policies
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: Subscribe
  },
  {
    path: '/unsubscribe/:storyID',
    name: 'Unsubscribe',
    component: Unsubscribe
  },
  {
    path: '/create',
    name: 'CreateStory',
    component: CreateStory
  },
  {
    path: '/story/:storyID',
    name: 'TitlePage',
    component: TitlePage
  },
  {
    path: '/read/:storyID/:pageID?',
    name: 'ReadStory',
    component: ReadStory
  },
  {
    path: '/howitworks',
    name: 'HowItWorks',
    component: HowItWorks
  }, {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
